/**
 * Single source of truth for the IMS brand palette.
 *
 * Mirrors `new-design.json` (primary coral, secondary sage, warm amber and the
 * neutral surfaces). The MUI theme and the global CSS custom properties both
 * read from these values so a future brand refresh only has to touch one file.
 */
export const BRAND = {
    primary: {
        main: '#D17270',
        light: '#F4C0BA',
        dark: '#6A2B3B',
        hover: '#BD5F5D',
        // Darker coral variants used when the brand colour carries small text
        // on a white surface (WCAG AA at normal text sizes).
        text: '#A94F4E',
        strong: '#B25452',
        contrastText: '#FFFFFF',
        onContainer: '#2C1818',
    },
    secondary: {
        main: '#6EA893',
        light: '#CBE3DA',
        dark: '#4F7F6E',
        hover: '#5C9480',
        contrastText: '#FFFFFF',
    },
    warm: '#E5A358',
    neutral: {
        background: '#FAF8F8',
        surface: '#FFFFFF',
        text: '#1F1A1C',
        textSecondary: '#746A6B',
        border: 'rgba(244, 192, 186, 0.3)',
    },
} as const;

export default BRAND;
